import React from "react";
import "./Projects.css";

const projects = [
    {
        id: 1,
        name: "Nika TCG",
        description:
            "A trading card game app that lets you collect, build decks, and battle. Track your card collection and craft winning strategies from your pocket.",
        image: "/img/app-nika.png",
        link: "https://apps.apple.com/us/app/nika-tcg/id6758277197",
        whiteBg: true,
    },
    {
        id: 2,
        name: "BJJ Companion",
        description:
            "Your Brazilian Jiu-Jitsu training partner. Log sessions, track techniques, and monitor your progress on the mats.",
        image: "/img/app-bjj.png",
        link: "https://apps.apple.com/us/app/bjj-companion/id6757926097",
    },
    {
        id: 3,
        name: "Cohabitt",
        description:
            "Shared living made simple. Manage expenses, chores, and house rules with your housemates in one clean, easy-to-use app.",
        image: "/img/app-cohabitt.png",
        link: "https://apps.apple.com/us/app/cohabitt/id6758615403",
        whiteBg: true,
    },
];

function Projects() {
    return (
        <section className="projects section" id="projects">
            <h2 className="section__title">Projects</h2>
            <span className="section__subtitle">Apps I've shipped</span>

            <div className="projects__list container">
                {projects.map((project, index) => {
                    const reversed = index % 2 !== 0;
                    return (
                        <div
                            key={project.id}
                            className={`projects__row${reversed ? " projects__row--reversed" : ""}`}
                        >
                            <div
                                className={`projects__img-wrapper${project.whiteBg ? " projects__img-wrapper--white" : ""}`}
                            >
                                <img
                                    src={project.image}
                                    alt={project.name}
                                    className="projects__img"
                                />
                            </div>

                            <div className="projects__info">
                                <h3 className="projects__name">{project.name}</h3>
                                <p className="projects__description">{project.description}</p>
                                <a
                                    href={project.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="projects__cta button button--flex"
                                >
                                    View on App Store
                                    <i className="bx bx-link-external button__icon"></i>
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}

export default Projects;
